export { default } from './TinyMCEWrapper';
